module.exports = __webpack_public_path__ + "account/assets/vk.f798ed0c.svg";